export default function Locate() {
    const context = {
        svgar: {
            slab: new LocateSvgarSlabContext(),
            path: new LocateSvgarPathContext(),
        }
    };
    return context;
}
class LocateSvgarSlabContext {
    constructor() {
        this.withIdFilter = "";
        this.withNameFilter = "";
        this.in = {
            svgar: {
                cube: this.locateInSvgarCube.bind(this),
            }
        };
    }
    withId(id) {
        this.withIdFilter = id;
        return this;
    }
    withName(name) {
        this.withNameFilter = name;
        return this;
    }
    locateInSvgarCube(cube) {
        let slabs = [];
        if (this.withIdFilter != "") {
            slabs = cube.slabs.filter(x => x.getId() == this.withIdFilter);
        }
        if (this.withNameFilter != "") {
            slabs = slabs.concat(cube.slabs.filter(x => x.getName() == this.withNameFilter));
        }
        return slabs[0];
    }
}
class LocateSvgarPathContext {
    constructor() {
        this.withIdFilter = "";
        this.in = {
            svgar: {
                cube: this.locateInSvgarCube.bind(this),
                slab: this.locateInSvgarSlab.bind(this),
            }
        };
        this.withIdFilter = "";
    }
    withId(name) {
        this.withIdFilter = name;
        return this;
    }
    locateInSvgarCube(cube) {
        if (this.withIdFilter == "") {
            return undefined;
        }
        let paths = [];
        cube.slabs.forEach(slab => {
            paths = paths.concat(slab.getAllGeometry());
        });
        if (this.withIdFilter != "") {
            paths = paths.concat(paths.filter(x => x.getId() == this.withIdFilter));
        }
        return paths.find(x => x.getId() == this.withIdFilter);
    }
    locateInSvgarSlab(slab) {
        let path = [];
        if (this.withIdFilter != "") {
            path = path.concat(slab.getAllGeometry().filter(x => x.getId() == this.withIdFilter));
        }
        return path[0];
    }
}
